import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function CableIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5 21C4.71667 21 4.47917 20.9042 4.2875 20.7125C4.09583 20.5208 4 20.2833 4 20V19H3V15C3 14.7167 3.09583 14.4792 3.2875 14.2875C3.47917 14.0958 3.71667 14 4 14H5V7C5 5.9 5.39167 4.95833 6.175 4.175C6.95833 3.39167 7.9 3 9 3C10.1 3 11.0417 3.39167 11.825 4.175C12.6083 4.95833 13 5.9 13 7V17C13 17.55 13.1958 18.0208 13.5875 18.4125C13.9792 18.8042 14.45 19 15 19C15.55 19 16.0208 18.8042 16.4125 18.4125C16.8042 18.0208 17 17.55 17 17V10H16C15.7167 10 15.4792 9.90417 15.2875 9.7125C15.0958 9.52083 15 9.28333 15 9V5H16V4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3H19C19.2833 3 19.5208 3.09583 19.7125 3.2875C19.9042 3.47917 20 3.71667 20 4V5H21V9C21 9.28333 20.9042 9.52083 20.7125 9.7125C20.5208 9.90417 20.2833 10 20 10H19V17C19 18.1 18.6083 19.0417 17.825 19.825C17.0417 20.6083 16.1 21 15 21C13.9 21 12.9583 20.6083 12.175 19.825C11.3917 19.0417 11 18.1 11 17V7C11 6.45 10.8042 5.97917 10.4125 5.5875C10.0208 5.19583 9.55 5 9 5C8.45 5 7.97917 5.19583 7.5875 5.5875C7.19583 5.97917 7 6.45 7 7V14H8C8.28333 14 8.52083 14.0958 8.7125 14.2875C8.90417 14.4792 9 14.7167 9 15V19H8V20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H5Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}